export type LinkPart = { type: 'text'; text: string } | { type: 'link'; url: string; label: string }

const URL_RE = /https?:\/\/[^\s<>"'`]+/gi
const SEGMENT_MAX = 24
const SHORT_PATH_MAX = 24

const count = (s: string, ch: string) => s.split(ch).length - 1

function trimTrailing(url: string): string {
  let u = url
  for (;;) {
    const last = u[u.length - 1]
    if (!last) return u
    if ('.,;:!?*'.includes(last)) u = u.slice(0, -1)
    else if (last === ')' && count(u, ')') > count(u, '(')) u = u.slice(0, -1)
    else if (last === ']' && count(u, ']') > count(u, '[')) u = u.slice(0, -1)
    else if (last === '}' && count(u, '}') > count(u, '{')) u = u.slice(0, -1)
    else return u
  }
}

function decode(s: string): string {
  try {
    return decodeURIComponent(s)
  } catch {
    return s
  }
}

const clip = (s: string, max: number) => (s.length > max ? `${s.slice(0, max - 1)}…` : s)

export function linkLabel(url: string): string {
  const m = /^https?:\/\/([^/?#]+)([^?#]*)/i.exec(url)
  if (!m) return url
  const host = m[1]!
    .replace(/^[^@]*@/, '')
    .toLowerCase()
    .replace(/^www\./, '')
  const segments = m[2]!.split('/').filter(Boolean).map(decode)
  if (segments.length === 0) return host
  const path = segments.join('/')
  if (path.length <= SHORT_PATH_MAX) return `${host}/${path}`
  const last = clip(segments[segments.length - 1], SEGMENT_MAX)
  return segments.length === 1 ? `${host}/${last}` : `${host}/…/${last}`
}

export function splitLinks(text: string): LinkPart[] {
  const parts: LinkPart[] = []
  let cursor = 0
  for (const match of text.matchAll(URL_RE)) {
    const url = trimTrailing(match[0])
    if (!/^https?:\/\/[^/?#]/i.test(url)) continue
    const start = match.index
    if (start > cursor) parts.push({ type: 'text', text: text.slice(cursor, start) })
    parts.push({ type: 'link', url, label: linkLabel(url) })
    cursor = start + url.length
  }
  if (cursor < text.length) parts.push({ type: 'text', text: text.slice(cursor) })
  return parts
}

export const hasLink = (text: string) => /https?:\/\/[^/?#\s]/i.test(text)
